import React from 'react';
import Paper from "@material-ui/core/Paper";
import { makeStyles, createStyles} from "@material-ui/core/styles";
import { styled } from '@mui/styles';
import Grid from '@mui/material/Grid';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1
    },
    paper: {
      textAlign: "center",
      padding:"4%"
    }
  })
);
//styling for Paper
export default function Padding()
{
    const classes = useStyles(); //styles for Paper component
    return(
        <Grid container><Paper className={classes.paper} elevation={0} style={{backgroundColor:"transparent"}}/></Grid>
    )
}